<template>
  <v-container fluid class="theme-color" style="height: 100%;">
    <EditReport class="dialog mb-sm-5" :class="{ xs: $vuetify.breakpoint.xsOnly }" />
  </v-container>
</template>

<script>
import EditReport from '../components/duplicate/EditReport.vue';

export default {
  name: 'EditDuplicate',
  data: () => ({
    // reportId: ''
  }),
  mounted() {
    // this.initParams();
  },
  methods: {
    // initParams() {
    //   this.reportId = this.$route.params.reportId || '';
    // }
  },
  components: { EditReport }
};
</script>
